
import React from "react";
import { MarketplaceStrategy } from "@/types/strategy-types";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";

interface RecommendedStrategiesProps {
  strategies: MarketplaceStrategy[];
  onSelectStrategy: (strategyName: string) => void;
}

const RecommendedStrategies = ({ strategies, onSelectStrategy }: RecommendedStrategiesProps) => {
  if (strategies.length === 0) {
    return (
      <div className="space-y-4">
        <p className="text-muted-foreground">No recommended strategies found for your profile.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {strategies.map((strategy) => (
        <Card key={strategy.id} className="overflow-hidden">
          <CardHeader className="bg-gradient-to-r from-blue-50 to-blue-100 dark:from-blue-950 dark:to-blue-900">
            <CardTitle className="text-lg">{strategy.name}</CardTitle>
          </CardHeader>
          <CardContent className="p-4 text-sm">
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Exchange:</span>
                <span className="font-medium">{strategy.exchange}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Risk level:</span>
                <span className="font-medium">{strategy.risk_level}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Performance:</span>
                <span className={`font-medium ${(strategy.performance_percentage || 0) > 0 ? 'text-green-600' : 'text-red-600'}`}>
                  {strategy.performance_percentage || 0}%
                </span>
              </div>
            </div>
          </CardContent>
          <CardFooter className="p-4 pt-0">
            <Button 
              variant="secondary" 
              className="w-full"
              onClick={() => onSelectStrategy(strategy.name)}
            >
              Learn More
            </Button>
          </CardFooter>
        </Card>
      ))}
    </div>
  );
};

export default RecommendedStrategies;
